import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
import { createStatusNext } from './createStatusNext';
export var defaultFocusable = {
  outlineStyle: 'dotted',
  outlineOffset: 0,
  outlineWidth: 2
};

var createFocusableSelected = function createFocusableSelected(palette) {
  return _assign({
    outlineColor: palette.white
  }, defaultFocusable);
};

var createOptions = function createOptions(getStatus, statuses) {
  var focusableStatus = {};

  for (var status in statuses) {
    var _getStatus = getStatus(status),
        outlineColor = _getStatus.status;

    focusableStatus[status] = _assign({
      outlineColor: outlineColor
    }, defaultFocusable);
  }

  return focusableStatus;
};

var createGetFocusable = function createGetFocusable(options) {
  return function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';
    var hasOwnProperty = Object.prototype.hasOwnProperty;

    if (hasOwnProperty.call(options, status)) {
      return options[status];
    }

    return undefined;
  };
};

export var createFocusable = function createFocusable(palette) {
  var focusable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _createStatusNext = createStatusNext(palette),
      getStatus = _createStatusNext.getStatus,
      statusStates = _createStatusNext.statusStates;

  var _ref = typeof focusable === 'function' ? focusable(palette) : focusable,
      otherGetFocusable = _ref.getFocusable,
      otherOptions = _objectWithoutProperties(_ref, ["getFocusable"]);

  var options = createOptions(getStatus, statusStates);
  options.selected = createFocusableSelected(palette);
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getFocusable: otherGetFocusable || createGetFocusable(mergedOptions),
    focusableStates: statusStates
  }, mergedOptions);
};